import { SectionItemsOptions } from './api';

export const layoutKeys = {
  all: ['layout'] as const,
  rootMenu: (subscriberId: string) => ['root-menu', subscriberId] as const,
  section: ['section'] as const,
  sectionItems: (options: SectionItemsOptions) => [...layoutKeys.section, options] as const,
  sectionItemsOnPageBySlug: (pageSlug: string, sectionSlug: string) =>
    [...layoutKeys.section, pageSlug, sectionSlug] as const,
  page: (slug: string) => ['page', slug] as const,
  paginatedPage: (slug: string) => ['paginated', slug] as const,
  pageMenuItems: (type: string, slug: string) => ['page-menu', type, slug] as const,
  pages: (slug: string, page: number) => ['pages', page, slug] as const,
  collectionsBySlug: (slug: string) => ['collections', slug] as const,
  allCollections: () => [...layoutKeys.all, 'collections'] as const,
  availablePages: () => [...layoutKeys.all, 'available-pages'] as const,
};
